import { render, staticRenderFns } from "./SaludBucal.vue?vue&type=template&id=adbdebc4"
import script from "./SaludBucal.vue?vue&type=script&lang=js"
export * from "./SaludBucal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports